import React from 'react';
import { IconBaseProps } from 'react-icons/lib';

const Icon = (props: IconBaseProps) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M5.99454 8.71744C6.42092 8.31466 7.08744 8.31429 7.51425 8.71662L11.9997 12.9447L16.4852 8.71662C16.912 8.31429 17.5785 8.31466 18.0049 8.71744C18.4674 9.15433 18.4674 9.8902 18.0049 10.3271L12.6864 15.3513C12.301 15.7154 11.6984 15.7154 11.313 15.3513L5.99454 10.3271C5.53206 9.8902 5.53206 9.15433 5.99454 8.71744Z"
			fill={props.color}
		/>
	</svg>
);

export default Icon;
